import React, { useEffect, useState } from "react";

const CompanyReviewForm = () => {
    const scriptSrc = "https://js.hsforms.net/forms/embed/5367608.js";
    const targetId = "hubspotFormContainer";
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

        const checkFormLoaded = () => {
            const interval = setInterval(() => {
                const formFrame = document.querySelector(`#${targetId} iframe`);
                if (formFrame) {
                    setLoading(false);
                    clearInterval(interval);
                }
            }, 300);
        };

        // If script not already loaded, append it
        if (!existingScript) {
            const script = document.createElement("script");
            script.src = scriptSrc;
            script.defer = true;
            document.body.appendChild(script);

            script.onload = () => {
                // Once the script loads, HubSpot automatically injects the form
                
                checkFormLoaded();
            };
        } else {
           
            checkFormLoaded();
        }
    }, []);

    return (
        <div className="row">
            <div className="col-lg-6">
                 <div className="card">
                     <div className="card-body">
             
                {loading && (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <div className="loader" />
                        <p>Loading form, please wait...</p>
                    </div>
                )}

                <div
                    className="hs-form-frame mt-2"
                    data-region="na1"
                    data-form-id="33021647-2518-4af4-aabd-bcc879165f7d"
                    data-portal-id="5367608"
                    id={targetId}
                ></div>
                </div>
                </div>
            </div>
            <div className="col-lg-6 bg-img">

            </div>
        </div>
    );
};

export default CompanyReviewForm;
 